/**
  MeshVariantKey describes overrides on a mesh.
  We can have one per (url, mesh_index).
  If we have data that we want to vary per instance look at instance buffers instead!
  NOTE: transform_positive_determinant scales the source mesh to give it the same winding as the instances. The sourceMesh transform is not used so it doesn't change how the instances look.
  NOTE: Enabling base_color_roughness_override on an instance is really a modification of the currently assigned material! Needs a MaterialVariantKey instead and a similar system.
*/
export class SceneAssetMeshVariantKey {
    constructor() {
        this.custom_material = null;
        this.receive_shadows = true;
        this.transform_positive_determinant = true; // TODO: Determine what is our default starting value
        this.transparent_model_id = null;
        this.custom_source_vertex_data_id = null;
        this.clip_plane = null;
        this._unique_id = SceneAssetMeshVariantKey._unique_id_counter++;
    }
    hash() {
        let hash = '';
        if (this.custom_material === null) {
            hash = '*';
        }
        else {
            // New material system place
            hash = this.custom_material.uniqueId.toString();
        }
        hash += '_' + (this.receive_shadows ? '1' : '0');
        hash += '_' + (this.transform_positive_determinant ? '1' : '0');
        hash += '_' + (this.transparent_model_id === null ? '*' : this.transparent_model_id);
        hash += '_' + (this.custom_source_vertex_data_id === null ? '*' : this.custom_source_vertex_data_id);
        if (this.clip_plane !== null) {
            hash += "_" + this._unique_id;
        }
        else {
            hash += "_-";
        }
        return hash;
    }
}
SceneAssetMeshVariantKey._unique_id_counter = 0;
//# sourceMappingURL=SceneAssetMeshVariantKey.js.map